var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      ref: "blockButton",
      class: [
        "question-mark-block-button link flat",
        { questionMarkBlockBounce: _vm.isBopping },
      ],
      style: _vm.buttonStyle,
      attrs: {
        role: "button",
        "aria-label": `It's a mystery block... ${_vm.selectedTeaser}`,
        "aria-pressed": _vm.isBopping,
        "data-balloon-pos":
          _vm.isShowingTooltip && !_vm.hasHitBopLimit ? "up" : null,
        tabindex: "-1",
      },
      on: { click: _vm.handleBop },
    },
    [
      !_vm.hasHitBopLimit
        ? _c(
            "span",
            { class: `fa-${_vm.blockSize}` },
            [
              _vm.isShowingHoverInitially
                ? _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.$v6.duotone.faBlockQuestion,
                      "fixed-width": "",
                    },
                  })
                : _c(
                    "span",
                    {
                      staticClass:
                        "swap-icons position-relative display-inline-block",
                      staticStyle: { "line-height": "0" },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "initial-icon",
                        attrs: {
                          icon: _vm.$v6.solid.faBlockQuestion,
                          "fixed-width": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("font-awesome-icon", {
                        staticClass: "hover-icon z-4",
                        attrs: {
                          icon: _vm.$v6.duotone.faBlockQuestion,
                          "fixed-width": "",
                        },
                      }),
                    ],
                    1
                  ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isShowingCoin,
                      expression: "isShowingCoin",
                    },
                  ],
                  staticClass:
                    "question-mark-block-button-coin questionMarkCoinkBounce position-absolute center-all z-foreground",
                  style: {
                    "--fa-animation-duration": "0.5s",
                    color: _vm.coinColor,
                  },
                },
                [
                  _c("font-awesome-icon", {
                    staticStyle: { "font-size": "0.5em" },
                    attrs: { icon: _vm.$v6.solid.faCoinFront, flip: "" },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _c("font-awesome-icon", {
            attrs: {
              icon: _vm.$v6.duotone.faBlock,
              "fixed-width": "",
              size: _vm.blockSize,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }